import * as http from 'utils/http';
import config from 'config';

const editPointOfInterest = async (data) => {
  const { id, ...rest } = data;

  return http.put(`${config.API_URL}places/${id}/`, rest);
};

const createPointOfInterest = async (data) => {
  return http.post(`${config.API_URL}places/`, data);
};

export { editPointOfInterest, createPointOfInterest };
